import type {supplierFunctionsRouteApi} from "./-route-api";
import type {z} from "zod";

import {listSupplierFunctionsSearchSchema as applicationListSupplierFunctionsSearchSchema} from "@project/application/engineering/supplier-functions";

export const listSupplierFunctionsSearchSchema =
  applicationListSupplierFunctionsSearchSchema.transform((search) => ({
    ...search,
    state: search.state === "DELETED" ? ("DELETED" as const) : ("ACTIVE" as const),
  }));

export type ListSupplierFunctionsSearch = z.output<typeof listSupplierFunctionsSearchSchema>;

export type SupplierFunctionsNavigateFn = ReturnType<typeof supplierFunctionsRouteApi.useNavigate>;
